import { observer } from 'mobx-react';
import { ReactNode } from 'react';
import { T } from '../../../../../Translations';

interface Props {
  onClick: () => void;
  children?: ReactNode;
  disabled?: boolean;
}

function PublishButton({ onClick, children, disabled = false }: Props) {
  return (
    <button
      className="px-6 py-2.5 bg-accent text-accent-foreground rounded-l-md transition-all hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed"
      style={{ fontSize: 'var(--text-sm)', fontWeight: 'var(--font-weight-medium)' }}
      onClick={onClick}
      disabled={disabled}
      data-intercom-target="builder-v2-publish-button"
    >
      {children || <T kind="Publish Collection" />}
    </button>
  );
}

export default observer(PublishButton);
